import { Paper, Tab, Tabs, tabClasses } from '@mui/material';
import { useState } from 'react';
import TabPanel from '../../components/TabPanel';
import { a11yProps } from '../../utils/tabProps';
import NotificationSettings from './NotificationSettings';
import ProfileSettings from './ProfileSettings';

const Settings = () => {
  const [currentTab, setCurrentTab] = useState(0);

  const handleChange = (_, newValue) => {
    setCurrentTab(newValue);
  };

  const baseTabId = 'settings-tab';

  return (
    <Paper sx={{ borderRadius: '8px' }} className='px-[35px] py-[16px] m-[30px]'>
      <div>
        <Tabs
          value={currentTab}
          onChange={handleChange}
          aria-label='settings tabs'
          sx={{
            minHeight: 'unset',
            [`& .${tabClasses.root}`]: {
              paddingX: 0,
              minHeight: 'unset',
              marginRight: '24px',
            },
          }}
        >
          <Tab label='Profile Settings' {...a11yProps(0, baseTabId)} />
          <Tab disabled label='Notification Settings' {...a11yProps(1, baseTabId)} />
        </Tabs>
      </div>
      <hr className='-mx-[35px] mb-[28px]' />
      <TabPanel baseTabId={baseTabId} value={currentTab} index={0}>
        <ProfileSettings />
      </TabPanel>
      <TabPanel baseTabId={baseTabId} value={currentTab} index={1}>
        <NotificationSettings />
      </TabPanel>
    </Paper>
  );
};

export default Settings;
